import "./info_section.scss";
